<template>
  <v-dialog
    v-model="shown"
    persistent
    scrollable
    max-width="400px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text style="hight=400px;">
        <span style="white-space: pre-wrap;">{{ message }}</span>
      </v-card-text>
      <v-divider />
      <v-card-actions class="justify-center">
        <v-btn
          class="font-weight-bold"
          color="cancel"
          text
          @click="close">閉じる
        </v-btn>
        <v-btn
          v-if="canDownload"
          class="font-weight-bold"
          color="cancel"
          text
          @click="download">結果ダウンロード
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
  
<script>
export default {
  props: {
    canDownload: {Boolean, default: false},
    downloadFname: {String, default: "結果ダウンロード.txt"},
  },
  data: () => ({
    shown: false,
    title: "",
    message: "",
  }),
  methods: {
    open(title, message) {
      this.title = title;
      this.message = message;
      this.shown = true;
    },
    close() {
      this.shown = false;
    },
    download() {
      const blob = new Blob([this.message]);
      const a = document.createElement("a");
      a.download = this.downloadFname;
      a.href = URL.createObjectURL(blob);
      a.click();
    }
  },
}
</script>

<style lang="scss" scoped>

</style>